import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { SubscribingComponent } from "app/common";
import { AuthModel } from "app/modules/user/models/auth/auth.model";
import { UserChangePasswordHttpService } from "app/modules/user/services/http/user-change-password.http.service";
import { State } from "app/reducers";
import { USER_LOGIN } from "app/reducers/actions/auth-user";
import { takeUntil } from "rxjs";
import { UserType } from "app/users/user-type";
import { User } from "app/users";
import { ErrorDialogComponent } from "app/common/error-dialog/error-dialog.component";
import { TranslateService } from "@ngx-translate/core";
@Component({
    selector: "app-force-change-password-dialog",
    templateUrl: "./force-change-password-dialog.component.html",
    styleUrls: ["./force-change-password-dialog.component.scss"],
    standalone: false
})
export class ForceChangePasswordComponent extends SubscribingComponent implements OnInit {
  public password = "";
  public isPasswordValidated = false;
  public userData: User;
  public userType = UserType;
  public errors = [];
  public allowCloseModal = false;
  public isPasswordChanged = false;
  public isLoading = false;
  constructor(
    public dialogRef: MatDialogRef<ForceChangePasswordComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userChangePasswordHttpService: UserChangePasswordHttpService,
    private store: Store<State>,
    private translate: TranslateService
  ) {
    super();
    this.userData = data.user;
  }

  ngOnInit(): void {
    if (this.userData.clientType === UserType.individual) {
      this.allowCloseModal = true;
    }
  }

  public handleSetPassword(value: string): void {
    this.password = value;
  }

  public handleChangePassword(): void {
    if (!this.isPasswordValidated) {
      this.translate
        .get("FORCE_CHANGE_PASSWORD.PASSWORD_VALIDATION_ERROR")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((message: string) => (this.errors = [message]));
      return;
    }

    this.isLoading = true;
    this.userChangePasswordHttpService
      .updatePassword(this.password)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response: any) => {
          const user: AuthModel = AuthModel.fromResponse(response);
          this.store.dispatch({ type: USER_LOGIN, payload: user });
          this.isPasswordChanged = true;
          this.isLoading = false;
        },
        error: (error) => {
          console.error("Error changing password:", error);
          if (error?.error?.new_password) {
            this.errors = error.error.new_password;
          } else {
            this.translate
              .get("FORCE_CHANGE_PASSWORD.ERROR_MESSAGE")
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((message: string) => this.showErrorDialog(message));
          }

          this.isLoading = false;
        }
      });
  }

  public handleSkipChangePassword() {
    this.userChangePasswordHttpService
      .skipChangePassword()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response: any) => {
          this.dialogRef.close();
        },
        error: (error) => {
          console.error("Error changing password:", error);
          if (error?.error?.new_password) {
            this.errors = error.error.new_password;
          } else {
            this.translate
              .get("FORCE_CHANGE_PASSWORD.SKIP_CHANGE_PASSWORD_ERROR")
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((message: string) => this.showErrorDialog(message));
          }
        }
      });
  }

  showErrorDialog(message: string) {
    const dialogRef = this.dialog.open(ErrorDialogComponent);
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.showEmail = true;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
